import {
  CLEAR_EDIT_VOLCANO_EVENT,
  GET_EDIT_VOLCANO_EVENT_REQUEST,
  CREATE_EDIT_VOLCANO_EVENT_REQUEST,
  UPDATE_EDIT_VOLCANO_EVENT_REQUEST,
  EDIT_VOLCANO_EVENT_LOCATION_REQUEST,
  EDIT_VOLCANO_EVENT_LOCATION_SEARCH_REQUEST,
  EDIT_VOLCANO_EVENT_EARTHQUAKE_REQUEST,
  EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_REQUEST,
  EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_REQUEST,
  EDIT_VOLCANO_EVENT_REFERENCE_REQUEST,
  EDIT_VOLCANO_EVENT_TSUNAMI_REQUEST,
  EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_REQUEST,
  EDIT_VOLCANO_EVENT_AGENT_REQUEST,
  EDIT_VOLCANO_EVENT_EARTHQUAKE_SORT,
  EDIT_VOLCANO_EVENT_LOCATION_SORT,
  EDIT_VOLCANO_EVENT_REFERENCE_SORT,
  EDIT_VOLCANO_EVENT_TSUNAMI_SORT,
  EDIT_VOLCANO_EVENT_OPEN_CONFIRMATION,
  EDIT_VOLCANO_EVENT_CANCEL_CONFIRMATION,
  EDIT_VOLCANO_EVENT_EARTHQUAKE_TOGGLE_COLUMN,
  EDIT_VOLCANO_EVENT_TSUNAMI_TOGGLE_COLUMN,
  EDIT_VOLCANO_EVENT_REFERENCE_TOGGLE_COLUMN,
  EDIT_VOLCANO_EVENT_VOLLOC_TOGGLE_COLUMN,
} from './volcanoEventEditReducer';

export const getVolcanoEvent = ({ id, history }) => ({ type: GET_EDIT_VOLCANO_EVENT_REQUEST, id, history });
export const clearEditVolcanoEvent = () => ({ type: CLEAR_EDIT_VOLCANO_EVENT });
export const createVolcanoEvent = ({
  data, formModel, location, goBack, history,
}) => ({
  type: CREATE_EDIT_VOLCANO_EVENT_REQUEST, data, formModel, location, goBack, history,
});
export const updateVolcanoEvent = ({
  data, id, formModel, location, goBack, history,
}) => ({
  type: UPDATE_EDIT_VOLCANO_EVENT_REQUEST, data, id, formModel, location, goBack, history,
});

export const getVolcanoLocations = ({ queryParameters, history }) => ({
  type: EDIT_VOLCANO_EVENT_LOCATION_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getVolcanoLocation = ({ id, history }) => ({ type: EDIT_VOLCANO_EVENT_LOCATION_REQUEST, id, history });

export const searchEarthquakes = ({ queryParameters, history }) => ({
  type: EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getEarthquake = ({ id, history }) => ({ type: EDIT_VOLCANO_EVENT_EARTHQUAKE_REQUEST, id, history });

export const searchReferences = ({ queryParameters, history }) => ({
  type: EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getReferences = ({ id, history }) => ({ type: EDIT_VOLCANO_EVENT_REFERENCE_REQUEST, id, history });

export const searchTsunamis = ({ queryParameters, history }) => ({
  type: EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getTsunami = ({ id, history }) => ({ type: EDIT_VOLCANO_EVENT_TSUNAMI_REQUEST, id, history });

export const getAgents = ({ history }) => ({ type: EDIT_VOLCANO_EVENT_AGENT_REQUEST, history });

export const sortVolcanoLocations = sort => ({ type: EDIT_VOLCANO_EVENT_LOCATION_SORT, sort });
export const sortEarthquakes = sort => ({ type: EDIT_VOLCANO_EVENT_EARTHQUAKE_SORT, sort });
export const sortTsunamis = sort => ({ type: EDIT_VOLCANO_EVENT_TSUNAMI_SORT, sort });
export const sortReferences = sort => ({ type: EDIT_VOLCANO_EVENT_REFERENCE_SORT, sort });
export const openEditConfirmation = ({ formData }) => ({ type: EDIT_VOLCANO_EVENT_OPEN_CONFIRMATION, formData });
export const cancelEditConfirmation = () => ({ type: EDIT_VOLCANO_EVENT_CANCEL_CONFIRMATION });

export const toggleEarthquakeColumns = visibleColumns => ({ type: EDIT_VOLCANO_EVENT_EARTHQUAKE_TOGGLE_COLUMN, visibleColumns });
export const toggleTsunamiColumns = visibleColumns => ({ type: EDIT_VOLCANO_EVENT_TSUNAMI_TOGGLE_COLUMN, visibleColumns });
export const toggleReferenceColumns = visibleColumns => ({ type: EDIT_VOLCANO_EVENT_REFERENCE_TOGGLE_COLUMN, visibleColumns });
export const toggleVolLocColumns = visibleColumns => ({ type: EDIT_VOLCANO_EVENT_VOLLOC_TOGGLE_COLUMN, visibleColumns });
